import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {LOCALE_CONFIG} from '@common-lib';

import {TranslationsService} from '../../pages-services';

@Component({
    selector: 'app-language-dropdown',
    templateUrl: 'language-dropdown.component.html',
    styleUrls: ['./language-dropdown.component.scss']
})
export class LanguageDropdownComponent implements OnInit {
    @Output('open') openEvent = new EventEmitter<{}>();
    @Output('change') changeEvent = new EventEmitter<{}>();

    languages = [];
    selectedLanguage: string = LOCALE_CONFIG.DEFAULT_LANGUAGE;

    constructor(private translationsService: TranslationsService) {
    }

    ngOnInit() {
        this.translationsService.getLocalizations().subscribe(data => this.languages = data.sort((a, b) => a.title.localeCompare(b.title)));
    }

    open() {
        this.openEvent.emit();
    }

    change(selectedLanguage) {
        this.changeEvent.emit(selectedLanguage);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/language-dropdown/language-dropdown.component.ts